import { Injectable } from '@angular/core';
import {BaseService,httpOptions} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ArticleCommentService extends BaseService{
  private url = 'api/comments';

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  getPage(object:any):Observable<any> {
    return this.http.post<any>(this.getUrl() + '/page', object, httpOptions).pipe(
      tap((object:any) => this.log(`getPage`)),
      catchError(this.handleError<any>('getPage'))
    );
  }
}
